import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import dayjs from 'dayjs'

import LandingAgencias from './agencias/LandingAgencias'
import CookieConsentComponent from './components/CoockieConsent'

import { LOCAL_STORAGE_VALUES } from '../../localStorage'
import useGoToTop from '../../hooks/useGoToTop'

const Landing = () => {
  const { code } = useParams()

  const currentInvitationCodeExpiredCompanyLocalStorage = JSON.parse(
    localStorage.getItem(
      LOCAL_STORAGE_VALUES.currentInvitationCodeExpiredCompanyLocalStorage
    )
  )

  useEffect(() => {
    if (code !== undefined) {
      if (code === currentInvitationCodeExpiredCompanyLocalStorage) {
        return
      } else {
        localStorage.setItem(
          LOCAL_STORAGE_VALUES.invitationCodeCompany,
          JSON.stringify(code)
        )
        localStorage.setItem(
          LOCAL_STORAGE_VALUES.currentInvitationCodeExpiredCompany,
          JSON.stringify(code)
        )
        localStorage.setItem(
          LOCAL_STORAGE_VALUES.invitationCodeTimeExpiredCompany,
          JSON.stringify(dayjs())
        )
      }
    }
  }, [code])

  useGoToTop()

  return (
    <>
      <CookieConsentComponent />
      <LandingAgencias />
    </>
  )
}

export default Landing
